export default {"src":"/_next/static/media/veteran-owned.7be1f3e3.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};